export default "__VITE_ASSET__CZ5X4qe9__"